import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme, { headerColor }) => ({
  noteCard: {
    width: "100%",
    height: "350px",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    border: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 500px)": {
      height: "100%",
    },
  },
  header: {
    display: "flex",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    backgroundColor: headerColor || "var(--app-surface-2)",
  },
  body: {
    height: "300px",
    overflow: "auto",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid var(--app-border)",
    padding: "20px",
    gap: "1rem",
  },
  deleteModal: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    padding: "10px 0 0 0",
  },
  btnsFlex: {
    display: "flex",
    gap: "0.5rem",
    width: "100%",
  },
  modalBtns: {
    width: "100%",
  },
  deleteModalIcon: {
    width: "50px",
  },

  // ---- redesigned template card (mirrors the Note Type Studio mockup) ----
  tcard: {
    width: "100%",
    minHeight: 190,
    display: "flex",
    flexDirection: "column",
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: 12,
    padding: 16,
    boxShadow: "0 1px 2px rgba(16, 24, 40, .05)",
    transition: ".12s",
    "&:hover": {
      borderColor: "var(--app-border-2, #D9DDE4)",
      boxShadow: "0 4px 12px rgba(16, 24, 40, .08)",
    },
  },
  tcHead: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: 10,
  },
  tcIcon: {
    width: 36,
    height: 36,
    borderRadius: 9,
    display: "grid",
    placeItems: "center",
    flex: "none",
  },
  tcName: {
    fontWeight: 700,
    fontSize: 14.5,
    color: "var(--app-text)",
    lineHeight: 1.3,
  },
  tcMeta: {
    fontSize: 12,
    color: "var(--app-text-faint, #8A93A2)",
    marginTop: 1,
  },
  tcKebab: {
    marginLeft: "auto",
  },
  tcDesc: {
    fontSize: 12.5,
    color: "var(--app-text-muted)",
    lineHeight: 1.5,
    minHeight: 36,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  tcApproval: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    marginTop: 12,
    paddingTop: 12,
    borderTop: "1px solid var(--app-border)",
  },
  tcApprovalLab: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--app-text)",
  },
  tcFoot: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 12,
    paddingTop: 12,
    borderTop: "1px solid var(--app-border)",
  },
  tcBadge: {
    fontSize: 10.5,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    padding: "2px 8px",
    borderRadius: 20,
  },
  tcBadgeSystem: {
    background: "var(--app-surface-2)",
    color: "var(--app-text-muted)",
    border: "1px solid var(--app-border)",
  },
  tcBadgeCustom: {
    background: "var(--app-surface-2)",
    color: "var(--app-text-muted)",
    border: "1px solid var(--app-border)",
  },
  tcBadgeApproval: {
    background: "var(--app-info-bg, #EFF8FF)",
    color: "var(--app-info-fg, #175CD3)",
    border: "1px solid var(--app-info-bd, #B2DDFF)",
  },
  tcFootSpacer: {
    flex: 1,
  },
  tcBtn: {
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    color: "var(--app-text)",
    fontSize: 12.5,
    fontWeight: 600,
    borderRadius: 8,
    padding: "7px 12px",
    cursor: "pointer",
    "&:hover": { background: "var(--app-surface-2)" },
  },
}));

export default useStyles;
